import { ArrowLeft } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useEffect, useState } from "react";
import API from "../../API/newIndex";
import Breadcrumbs from "../../controllers/breadCrumbs";
import { parentNavigate } from "../../controllers/ParentNavigate";
import Notification from "../Notification";
import Loader from "../Loader/Loader";
import { ButtonComponent } from '@shopeasy-dashboard-ui/ui-library';

const ProductReview = () => {
  const [loading, setLoading] = useState(true);
  const [review_option, setreviewOption] = useState("logged_user");
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();

  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };

  const getClientData = async () => {
    setLoading(true);
    try {
      const res = await API({ url: "/admin/client/getClient", method: "get" });
      if (res?.data?.data) {
        setreviewOption(res.data.data.review_option || "logged_user");
      }
    } catch (error) {
      console.error("Error fetching client info:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getClientData();
  }, []);

  const HandleSubmit = async () => {
    try {
      const body = {
        clientInfo: {
          review_option,
        },
      };

      const ApiCall = await API({
        url: "/admin/client/updateClient",
        method: "put",
        data: body,
      });

      if (ApiCall.status === 200 || ApiCall.status === 304) {
        setIsNotification(true);
        setNotificationMsg(t("lang_Profile_Updated_SuccessFully"));
        setSeverity("success");
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(typeof error === "string" ? error : error?.message || "Something went wrong");
      setSeverity("error");
    }
  };

  if (loading) {
    return (
      <div className="absolute-loader">
        <Loader />
      </div>
    );
  }

  return (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}
      <div className="h-auto overflow-y-auto pb-[130px] pt-5">
        <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto">
          <div className="flex items-center space-x-2 page-header-pb">
            <button
              onClick={(e) => {
                e.preventDefault();
                parentNavigate("/reviews");
              }}
              className="back-arrow"
            >
              <ArrowLeft />
            </button>
            <div>
              <Breadcrumbs
                crumbs={[
                  { name: t("lang_dashboard"), path: "/dashboard" },
                  { name: t("lang_Reviews"), path: "/reviews" },
                  { name: t("lang_Product_Review"), path: "/reviews/setting" },
                ]}
              />
              <h4 className="text-xl md:text-2xl font-semibold text-primary">
                {t("lang_Product_Review")}
              </h4>
            </div>
          </div>
          <div className="secondary-bg-color table-text border main-border-color space-y-4 rounded-[6px] p-5 sm:p-[25px]">
            <div className="w-full">
              <div className="text-base font-medium text-primary">
                {t("lang_Product_Review")}
                <p className="text-xs table-text font-normal mt-1">
                  {t("lang_Manage_who_can_add_review_in_product")}
                </p>
              </div>
            </div>
            <div className="text-sm table-text w-full">
              <label className="flex cursor-pointer justify-between items-center px-3 py-2 border main-border-color rounded-[6px]">
                <p className="text-md me-2">{t("lang_Logged_in_user_can_review")}</p>
                <input
                  type="radio"
                  id="flexSwitchCheckDefault1"
                  checked={review_option === "logged_user"}
                  name="review_option"
                  value="logged_user"
                  onChange={() => setreviewOption("logged_user")}
                />
              </label>
              <label className="flex cursor-pointer px-3 py-2 border main-border-color rounded-[6px] justify-between items-center mt-4">
                <p className="text-md me-2">{t("lang_User_who_purchased_product_can_review")}</p>
                <input
                  type="radio"
                  id="flexSwitchCheckDefault2"
                  checked={review_option === "product_purchased_user"}
                  name="review_option"
                  value="product_purchased_user"
                  onChange={() => setreviewOption("product_purchased_user")}
                />
              </label>
              <label className="flex cursor-pointer px-3 py-2 border main-border-color rounded-[6px] justify-between items-center mt-4">
                <p className="text-md me-2">{t("lang_Allow_all_review")}</p>
                <input
                  type="radio"
                  id="flexSwitchCheckDefault3"
                  checked={review_option === "all_user"}
                  name="review_option"
                  value="all_user"
                  onChange={() => setreviewOption("all_user")}
                />
              </label>
              <div className="w-full flex justify-end mt-4">
                <ButtonComponent
                  type="button"
                  onClick={() => HandleSubmit()}
                >
                  {t("lang_Submit")}
                </ButtonComponent>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductReview;
